import {useCallback, useMemo, useState} from "react";
import {
	InputField,
	SelectUserAll,
	SelectCustomerAll,
	SelectField,
	DateField
} from "~/components/Forms";
import {StatusLabel} from "~/components";
import {useCan, useUtilities} from "~/hooks";
import {getGroupSelectOption, strToTime} from "../../../../utils";

function ContractSearchBar({filter, listGroup, onSearchChange, onChange}) {

	const {utilities} = useUtilities();

	const can = {
		listAll: useCan('contractListAll'),
		listGroup: useCan('contractListGroup'),
		add: useCan('contractAdd'),
		edit: useCan('contractEdit'),
		transfer: useCan('contractTransfer'),
		delete: useCan('contractDelete'),
		status: useCan('contractStatus'),
		paperStatus: useCan('contractStatus'),
	};

	const [optionsUser, setOptionsUser] = useState([{value:'', label:'Tất cả'}]);

	const serviceOptions = useMemo(() => {
		return [{ value: '', label: 'Tất cả' }, ...Object.entries(utilities.services).map(([key, value]) => {
			return {
				value: key,
				label: <StatusLabel small type={value.color}>{value.label}</StatusLabel>
			};
		})];
	}, [utilities.services]);

	const statusOptions = useMemo(() => {
		return [{ value: '', label: 'Tất cả' }, ...utilities.status.contract.map((item) => {
			return {
				value: item.key,
				label: <StatusLabel small type={item.badge}>{item.label}</StatusLabel>
			};
		})];
	}, [utilities.status.contract]);

	const statusPaperOptions = useMemo(() => {
		return [{ value: '', label: 'Tất cả' }, ...utilities.status.contractPaper.map((item) => {
			return {
				value: item.key,
				label: <StatusLabel small type={item.badge}>{item.label}</StatusLabel>
			};
		})];
	}, [utilities.status.contractPaper]);

	const groupOptions = Object.values(getGroupSelectOption(listGroup));

	const handleKeywordChange = (e) => {
		if (!onSearchChange) return;
		const newFilter = {
			...filter,
			keyword: e.target.value,
			page: 1,
		};
		onSearchChange(newFilter);
	}

	const handleUserChange = useCallback((value) => {
		if(onChange) onChange('userId', value);
	}, [onChange]);

	const handleCustomerChange = useCallback((value) => {
		if(onChange) onChange('customerId', value);
	}, [onChange]);

	const handleServiceChange = useCallback((value) => {
		if(onChange) onChange('service', value);
	}, [onChange]);

	const handleStatusChange = useCallback((value) => {
		if(onChange) onChange('status', value);
	}, [onChange]);

	const handlePaperStatusChange = useCallback((value) => {
		if(onChange) onChange('paperStatus', value);
	}, [onChange]);

	const handleGroupChange = useCallback((value) => {
		if(onChange) onChange('groupId', value);
	}, [onChange]);

	const handleTimeChange = useCallback((value) => {
		value = strToTime(value);
		if(onChange) onChange('signing', value);
	}, [onChange]);

	return (
		<div className="search-bar">
			<div className="container">
				<form className="form" autoComplete="off">
					{(can.listAll) && <DateField value={filter.time} name="signing" placeholder="Tháng ký" picker="month" onChange={handleTimeChange}/>}
					<InputField defaultValue={filter.keyword} placeholder="Tên miền, tên, số hợp đồng" onChange={handleKeywordChange} />
					<SelectCustomerAll defaultValue={filter.customerId} value={filter.customerId} placeholder="Khách hàng" options={[{value:'', label:'Tất cả'}]} onChange={handleCustomerChange} />
					{(can.listAll || can.listGroup) && <SelectField placeholder="Chọn nhóm" options={groupOptions} onChange={(value, event) => handleGroupChange(value)} />}
					{(can.listAll || can.listGroup) && <SelectUserAll value={filter.userId} placeholder="Nhân viên" options={optionsUser} setOptions={setOptionsUser} onChange={handleUserChange} />}
					<SelectField value={filter.service} placeholder="Dịch vụ" options={serviceOptions} onChange={handleServiceChange}/>
					<SelectField value={filter.status} placeholder="Trạng thái" options={statusOptions} onChange={handleStatusChange}/>
					{(can.listAll) && <SelectField value={filter.paperStatus} placeholder="Trạng thái thu hồi" options={statusPaperOptions} onChange={handlePaperStatusChange}/>}
				</form>
			</div>
		</div>
	)
}

export default ContractSearchBar;